export const CERTIFICATES_TYPES: any = {
  Cliente: 'naturalPerson',
  Abogado: 'qualifiedProfessional',
};

export const DOCUMENT = '08763281319';
export const DOCUMENT_TYPE = 'E';
export const APACUANA_ID = '';
export const MEDIAPIPE_URL = 'https://apacuanawebdev.web.app/assets/mediapipe';
const {
  REACT_APP_APACANA_API_URL,
  REACT_APP_APACANA_API_KEY,
  REACT_APP_APACANA_VERIFICATION_ID_CLIENT,
  REACT_APP_APACANA_VERIFICATION_ID_LAWYER,
  REACT_APP_APACANA_ENCRYPTION_KEY,
  REACT_APP_APACANA_INTEGRATION_TYPE,
} = process.env;

// El `secretKey` ya NO va aquí: es un accessToken que vence cada 24h y lo
// renueva el backend (Legalmente-Api, ApacuanaTokenService). ApacuanaContext lo
// pide con ApacuanaService.getToken() y lo agrega a esta config antes de init().
export const sdkConfigNaturalPerson = {
  apiUrl: REACT_APP_APACANA_API_URL,
  apiKey: REACT_APP_APACANA_API_KEY,
  verificationId: REACT_APP_APACANA_VERIFICATION_ID_CLIENT,
  encryptionKey: REACT_APP_APACANA_ENCRYPTION_KEY,
  integrationType: REACT_APP_APACANA_INTEGRATION_TYPE,
};

export const sdkConfigProfessional = {
  apiUrl: REACT_APP_APACANA_API_URL,
  apiKey: REACT_APP_APACANA_API_KEY,
  verificationId: REACT_APP_APACANA_VERIFICATION_ID_LAWYER,
  encryptionKey: REACT_APP_APACANA_ENCRYPTION_KEY,
  integrationType: REACT_APP_APACANA_INTEGRATION_TYPE,
};
